export class Mapper {
    constructor() {
        if (new.target === Mapper) {
          throw new Error("Cannot instantiate abstract class Mapper directly.");
        }
      }
    
      getMapper() {
        throw new Error("You must implement the getMapper() method.");
      }
}
export class DeminimisMapper extends Mapper {
        constructor(form){
          super();
          this.form = form;
        }

        getField = (name) => {
            const input = this.form.elements[this.form.name + `[${name}]`];
            return input ? input.value : '';
        }

        getRadioX = (name, index) => {
            const input = this.form.elements[this.form.name + `[${name}]`]?.[index];
            return input && (input.checked || input.selected) ? true : false;
        }

        getRadioLabel = (name, index) => {
            const input = this.form.elements[this.form.name + `[${name}]`]?.[index];
            return input && (input.checked || input.selected) ? input.labels[0].innerText : '';
        }
    
        getMapper() {
          const formaprawna = this.form.querySelector("[name*=legalform]:checked");
          const innaFormaprawna = this.form.querySelector("[name*=other_radio]:checked");
        var mapper = {
            'CZY_KOREKTA': {page:0, x: 271.97, y: 745.5, text: this.getRadioX('regist', 1) ? 'KOREKTA' : '' },
            'NAZWA': this.getField('subjectname'),
            'ADRES_SIEDZIBY_ULICA' : this.getField('street')+ " "+ this.getField('houseNumber') + (this.getField('flatnumber') ? '/'+ this.getField('flatnumber') : ''),
            'ADRES_SIEDZIBY_MIEJSCOWOSC' : this.getField('postalcode') + " "+this.getField('city'),
            'NIP_PESEL' : this.getRadioX("braknip", 0) ? this.getField('nip') : (this.getRadioX("braknip", 1) ? this.getField('pesel') : this.getField('foraignnip')) ,
            'TELEFON': this.getField("phone"),
            'EMAIL': this.getField("email"),
            'IDENTYFIKATOR_GMINY':this.getField("communeid"),
            'PRZEDSIEBIORSTWO_PANSTWOWE':this.getRadioX("other_radio", 0),
            'JEDNOOSOBOWA_SPOLKA_SKARBU_PANSTWA': this.getRadioX("other_radio", 1),
            'JEDNOOSOBOWA_SPOLKA_JEDNOSTKI': this.getRadioX("other_radio", 2),
            'SPOLKA_AKCYJNA': this.getRadioX("other_radio", 3),
            'JEDNOSTKA_SEKTORA_FINANSOW_PUBLICZNYCH': this.getRadioX("other_radio", 4),
            'INNA_JAKA': formaprawna.value != "inna_spolka" || innaFormaprawna.value == 'inna_jaka' || (formaprawna.value == 'inna_spolka' && formaprawna.value == 'inna_jaka'),
        }

        if(formaprawna.value != 'inna_spolka')
        {
          mapper['INNA_OPIS'] = this.getRadioLabel('legalform', Array.from(this.form[this.form.name+"[legalform]"]).findIndex(r => r.checked));
        }
        else if(innaFormaprawna.value == 'inna_jaka')
        {
          mapper['INNA_OPIS'] = this.getField('inna_textarea');
        }
        
        switch (this.form[this.form.name+"[subjectsize]"].value) {
          case 'mikroprzedsiebiorstwo':
            mapper = {
              ...mapper,
              'MIKROPRZEDSIEBIORSTWO_INNE': this.getRadioX('subjectactivity', 1),
              'MIKROPRZEDSIEBIORSTWO_SEKTOR_PRODUKCJI': this.getRadioX('subjectactivity', 2),
              'MIKROPRZEDSIEBIORSTWO_SEKTOR_RYBOLOSTWA': this.getRadioX('subjectactivity', 3),
              'MIKRO_NIE_UZYSKANO_POMOCY': this.getRadioX('oswiadczeniepodmiotu', 0),
              'MIKRO_UZYSKANO_POMOC':this.getRadioX('oswiadczeniepodmiotu', 1),
              'MIKRO_POMOC_PLN': this.getRadioX('oswiadczeniepodmiotu', 1) ? this.getField('pomocpln') : '',
              'MIKRO_POMOC_EURO':this.getRadioX('oswiadczeniepodmiotu', 1) ? this.getField('pomoceur') : '',
              'MIKRO_PODLEGAM':this.getRadioX('wykluczenia', 1),
              'MIKRO_NIE_PODLEGAM':this.getRadioX('wykluczenia', 0),
              'MIKRO_CIAZY_OBOWIAZEK':this.getRadioX('field_46998',1),
              'MIKRO_NIE_CIAZY_OBOWIAZEK':this.getRadioX('field_46998',0),
              'MIKRO_JESTEM_PRZEDSIEBIORSTWEM':this.getRadioX('field_47263',1),
              'MIKRO_NIE_JESTEM_PRZEDSIEBIORSTWEM':this.getRadioX('field_47263',0)
            };
            break;
          case 'male_przedsiebiorstwa':
            mapper = {
              ...mapper,
              'MALE_PRZEDSIEBIORSTWO_INNE': this.getRadioX('subjectactivity', 1),
              'MALE_PRZEDSIEBIORSTWO_SEKTOR_PRODUKCJI': this.getRadioX('subjectactivity', 2),
              'MALE_PRZEDSIEBIORSTWO_SEKTOR_RYBOLOSTWA': this.getRadioX('subjectactivity', 3),
            };
            break;
          case 'srednie_przedsiebiorstwo':
            mapper = {
              ...mapper,
              'SREDNIE_PRZEDSIEBIORSTWO_INNE': this.getRadioX('subjectactivity', 1),
              'SREDNIE_PRZEDSIEBIORSTWO_SEKTOR_PRODUKCJI': this.getRadioX('subjectactivity', 2),
              'SREDNIE_PRZEDSIEBIORSTWO_SEKTOR_RYBOLOSTWA': this.getRadioX('subjectactivity', 3),
            };
            break;
        }
            
        mapper.PKD = this.getField('pkd'+this.form[this.form.name+"[rokpkd]"].value);

        if((this.form[this.form.name+"[legalform]"].value).startsWith('spolka_') && (this.form[this.form.name+"[legalform]"].value != 'spolka_akcyjna' || this.form[this.form.name+"[legalform]"].value != 'spolka_zoo'))
        {

          mapper = {
            ...mapper,
           'SPOLKA_CYWILNA_NAZWA': this.getField('subjectf'),
            'SPOLKA_CYWILNA_ADRES_SIEDZIBY_ULICA': this.getField('streetf') + " "+ this.getField('housenumberf') + (this.getField('apartamentnumberf') ? '/'+ this.getField('apartamentnumberf') : ''),
            'SPOLKA_CYWILNA_ADRES_SIEDZIBY_MIEJSCOWOSC': this.getField('postalcodef') + " " +this.getField('cityf'),
            'SPOLKA_CYWILNA_NIP_PESEL': this.getRadioX('braknipf', 0) ? this.getField('nipf') : this.getField('peself'),
            'SPOLKA_CYWILNA_TELEFON': this.getField('telf'),
            'SPOLKA_CYWILNA_EMAIL':this.getField('emailf')
          };

        }

        if(this.form[this.form.name+"[subjectsize]"].value != 'mikroprzedsiebiorstwo')
        {
          if(this.form[this.form.name+"[subjectactivity]"].value == 'sektor_rybolostwa')
          {
            mapper = {
              ...mapper,
            'RYBOLOSTWO_NIE_UZYSKANO_POMOCY': this.getRadioX('pomocdeminimisrybolostwo', 0),
            'RYBOLOSTWO_UZYSKANO_POMOC':this.getRadioX('pomocdeminimisrybolostwo', 1),
            'RYBOLOSTWO_POMOC_PLN': this.getRadioX('pomocdeminimisrybolostwo', 1) ? this.getField('field_52306') : '' ,
            'RYBOLOSTWO_POMOC_EURO':this.getRadioX('pomocdeminimisrybolostwo', 1) ? this.getField('field_52964') : '' ,
            'RYBOLOSTWO_ROLNICTWO_NIE_UZYSKANO_POMOCY':this.getRadioX('deminimissektorrolnictwo', 0),
            'RYBOLOSTWO_ROLNICTWO_UZYSKANO_POMOC':this.getRadioX('deminimissektorrolnictwo', 1),
            'RYBOLOSTWO_ROLNICTWO_POMOC_PLN':this.getRadioX('deminimissektorrolnictwo', 1) ? this.getField('field_53293') : '' ,
            'RYBOLOSTWO_ROLNICTWO_POMOC_EURO':this.getRadioX('deminimissektorrolnictwo', 1) ? this.getField('field_53622') : '' ,
            'RYBOLOSTWO_RYBOLSTWO_NIE_UZYSKANO_POMOCY':this.getRadioX('field_17367', 0),
            'RYBOLOSTWO_RYBOLSTWO_UZYSKANO_POMOC':this.getRadioX('field_17367', 1),
            'RYBOLOSTWO_RYBOLSTWO_POMOC_PLN':this.getRadioX('field_17367', 1) ? this.getField('field_53951') : '' ,
            'RYBOLOSTWO_RYBOLSTWO_POMOC_EURO':this.getRadioX('field_17367', 1) ? this.getField('field_54280') : '' 
            };
          }
          else
          {
            mapper = {
              ...mapper,
            'ROLNICTWO_NIE_UZYSKANO_POMOCY': this.getRadioX('pomocdeminimis', 0),
            'ROLNICTWO_UZYSKANO_POMOC':this.getRadioX('pomocdeminimis', 1),
            'ROLNICTWO_POMOC_PLN': this.getRadioX('pomocdeminimis', 1) ? this.getField('field_50003') : '' ,
            'ROLNICTWO_POMOC_EURO':this.getRadioX('pomocdeminimis', 1) ? this.getField('field_50332') : '' ,
            'ROLNICTWO_ROLNICTWO_NIE_UZYSKANO_POMOCY':this.getRadioX('pomocrolnictwo', 0),
            'ROLNICTWO_ROLNICTWO_UZYSKANO_POMOC':this.getRadioX('pomocrolnictwo', 1),
            'ROLNICTWO_ROLNICTWO_POMOC_PLN':this.getRadioX('pomocrolnictwo', 1) ? this.getField('field_50661') : '' ,
            'ROLNICTWO_ROLNICTWO_POMOC_EURO':this.getRadioX('pomocrolnictwo', 1) ? this.getField('field_50990') : '' ,
            'ROLNICTWO_RYBOLSTWO_NIE_UZYSKANO_POMOCY':this.getRadioX('pomocrybolostwo', 0),
            'ROLNICTWO_RYBOLSTWO_UZYSKANO_POMOC':this.getRadioX('pomocrybolostwo', 1),
            'ROLNICTWO_RYBOLSTWO_POMOC_PLN':this.getRadioX('pomocrybolostwo', 1) ? this.getField('field_51319') : '' ,
            'ROLNICTWO_RYBOLSTWO_POMOC_EURO':this.getRadioX('pomocrybolostwo', 1) ? this.getField('field_51648') : '' 
          }
        }

        }
        
        var namesSurname = this.form.querySelectorAll(`input[name^="${this.form.name}[reprezentant]["][name$="[nameSurname]"]`);
        var positions = this.form.querySelectorAll(`input[name^="${this.form.name}[reprezentant]["][name$="[position]"]`);
        for(let i = 0; i<namesSurname.length; i++)
        {
          mapper[`ODBIORCA_IMIE_NAZWISKO_${i+1}`] = namesSurname[i].value;
          mapper[`ODBIORCA_STANOWISKO_${i+1}`] = positions[i].value;
          //ODBIORCA_DATA_af_date_3
        }

        return mapper;
    }
}